<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Add Trade Name</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%;">
      <v-form ref="addTradeNameForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12>
            <v-text-field
              outline
              label="Trade Name *"
              required
              v-model="newItem.name"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-textarea v-model="newItem.notes" outline label="Notes"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="clearForm">Clear</v-btn>      
      <v-btn
        color="blue"
        @click="newItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
      >Add</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: {
        name: "",
        notes: ""
      },
      // categories: []
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded() {
      this.$emit("added");
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addTradeNameForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addTradeNameForm.reset();
    },
    resetValidation() {
      this.$refs.addTradeNameForm.resetValidation();
    },
    clearForm() {
      this.newItem.name = "";
      this.newItem.notes = "";
    },
    newItemDo() {
      if (this.$refs.addTradeNameForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/trade", this.newItem).then(res => {
          if (res.data.success) {
            this.onNewItemAdded();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    }
  },
  mounted() {}
};
</script>